import { render } from "./RidersInfo.vue?vue&type=template&id=192561b5"
import script from "./RidersInfo.vue?vue&type=script&lang=js"
export * from "./RidersInfo.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__